import { Accordion, Container, Image, Navbar } from 'react-bootstrap';
import '../../App.css';
import * as React from 'react';
import { Link } from 'react-router-dom';
import DescriptionIcon from '@mui/icons-material/Description';
function NavbarVerical() {
  // return (
  //   <nav class="nav flex-column navbarvertical">
  //   <Link className="nav-link" to="/page-configuration">
  //       Page Configuration
  //     </Link>
  //     <Link className="nav-link" to="/course-wise-document">
  //       Course-wise Document
  //     </Link>
  //     <Link className="nav-link" to="/category-type">
  //       Category Type
  //     </Link>


  //     <Link className="nav-link" to="/registration-fees">
  //       Registration Fees
  //     </Link>

  //     <Link className="nav-link" to="/instruction-upload">
  //       Instruction Upload
  //     </Link>
  //   </nav>
  // );
  return (
    <nav className="nav flex-column navbarvertical">
      <Accordion>
        <Accordion.Item eventKey="0">
          <Accordion.Header className="accordion-header">Master</Accordion.Header>
          <Accordion.Body className="accordion-body">
            <Link className="nav-link" to="/registration-fees">
              Registration Fees<DescriptionIcon className='accordianicon' />
            </Link>
            <Link className="nav-link" to="/category-type">
              Category Type<DescriptionIcon className='accordianicon' />
            </Link>
            <Link className="nav-link" to="/social-reservation">
              Social Reservation <DescriptionIcon className='accordianicon' />
            </Link>

            <Link className="nav-link" to="/instruction-upload">
              Instruction Upload<DescriptionIcon className='accordianicon' />
            </Link>
          </Accordion.Body>
        </Accordion.Item>

        <Accordion.Item eventKey="1">
          <Accordion.Header className="accordion-header">Page Configuration</Accordion.Header>
          <Accordion.Body className="accordion-body">
            <Link className="nav-link" to="/page-configuration">
              Page Configuration<DescriptionIcon className='accordianicon' />
            </Link>
          </Accordion.Body>
        </Accordion.Item>

        <Accordion.Item eventKey="2" >
          <Accordion.Header className="accordion-header">Document Configuration</Accordion.Header>
          <Accordion.Body className="accordion-body">
            <Link className="nav-link" to="/course-wise-document">
              Course-wise Document<DescriptionIcon className='accordianicon' />
            </Link>
          </Accordion.Body>
        </Accordion.Item>

        <Accordion.Item eventKey="3">
          <Accordion.Header className="accordion-header">Admin Activity</Accordion.Header>
          <Accordion.Body className="accordion-body">
            <Link className="nav-link" to="/update-student-details">
              Update Student Details<DescriptionIcon className='accordianicon' />
            </Link>
            <Link className="nav-link" to="/student-bulk-verification">
            Student Bulk Verification<DescriptionIcon className='accordianicon' />
            </Link>

            <Link className="nav-link" to="/unlock-registration">
              Unlock Registration<DescriptionIcon className='accordianicon' />
            </Link>
          </Accordion.Body>
        </Accordion.Item>

        <Accordion.Item eventKey="4">
          <Accordion.Header className="accordion-header">Date Configuration</Accordion.Header>
          <Accordion.Body className="accordion-body">
            <Link className="nav-link" to="/date-configuration">
              Date Configuration<DescriptionIcon className='accordianicon' />
            </Link>
          </Accordion.Body>
        </Accordion.Item>

        <Accordion.Item eventKey="5">
          <Accordion.Header className="accordion-header">Application Configuration</Accordion.Header>
          <Accordion.Body className="accordion-body">
            <Link className="nav-link" to="/application-configuration">
              Application Configuration<DescriptionIcon className='accordianicon' />
            </Link>
          </Accordion.Body>
        </Accordion.Item>

        <Accordion.Item eventKey="6">
          <Accordion.Header className="accordion-header">Project Configuration</Accordion.Header>
          <Accordion.Body className="accordion-body">
            <Link className="nav-link" to="/project-configuration">
              Project Configuration<DescriptionIcon className='accordianicon' />
            </Link>
          </Accordion.Body>
        </Accordion.Item>
      </Accordion>
    </nav>
  );
};

export default NavbarVerical;